class BlogContent extends HTMLElement {
  constructor() {
    super();

    this.tags = this.querySelectorAll('[data-filter-tag]');

    this.querySelector('form').addEventListener('change', this.filterBlogs.bind(this));
  }

  filterBlogs(e) {
    this.tags.forEach((tag) => {
      if(e.target.id !== tag.id) {
        tag.checked = false
      }
    });
    const urlToFetch = this.getFetchURL();
    this.getFilterResults(urlToFetch);
  }

  updateURLHash(tagsParams) {
    history.pushState({ }, '', `${this.dataset.blogUrl}${tagsParams !== '' ? '/tagged/' + tagsParams: ''}`);
  }

  getFilterResults(tagsParams) {
    let _that = this;
    const fetchUrl = `${this.dataset.blogUrl}${tagsParams !== '' ? '/tagged/' + tagsParams: ''}?section_id=${this.dataset.sectionId}`;
    document.body.classList.add('content-loading');
    fetch(fetchUrl)
      .then(response => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        let articlesContent = document.querySelector('.blog-articles__content');

        articlesContent.innerHTML = html.querySelector('.blog-articles__content').innerHTML;

        document.body.classList.remove('content-loading');
        this.updateURLHash(tagsParams)
      });
  }

  getFetchURL() {
    let returnUrl = '';
    this.tags.forEach((tag) => {
      if(tag.checked) {
        returnUrl += (returnUrl === '' ? tag.dataset.filterTag : '+' + tag.dataset.filterTag);
      }
    });

    return returnUrl;
  }
}

customElements.define('blog-content', BlogContent);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);